module.exports = __webpack_public_path__ + "img/enter-gray.a2c7d835.svg";